import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="onboarding--account-show-more"
export default class extends Controller {
  static targets = ["section", "button", "buttonText", "icon"]

  connect() {
    this.showMore = false
  }

  toggle() {
    this.showMore = !this.showMore
    this.buttonTextTarget.textContent = this.showMore
      ? this.buttonTarget.dataset.hideText
      : this.buttonTarget.dataset.showText
    this.iconTarget.innerHTML = this.showMore
      ? '<span class="material-symbols-outlined">arrow_drop_up</span>'
      : '<span class="material-symbols-outlined">arrow_drop_down</span>'
    this.sectionTargets.forEach((section, index) => {
      section.classList.toggle("on-section__data--hidden")
      setTimeout(() => {
        section.classList.toggle("on-section__data--visible")
      }, index * 100)
    })
    this.buttonTarget.classList.add("d-none")
  }
}
